module.exports = __webpack_public_path__ + "img/info.0d4c74a5.svg";